import { useRef } from "react";
import "../styles/promo.css";

function PromoCard() {
  const scrollRef = useRef(null);

  const promos = [
    {
      url: "https://store.storeimages.cdn-apple.com/1/as-images.apple.com/is/iphone-17-pro-model-unselect-gallery-2-202509_GEO_US?wid=5120&hei=2880&fmt=webp&qlt=90&.v=dU9qRExIQUlQTzVKeDd1V1dtUE1MUWFRQXQ2R0JQTk5udUZxTkR3ZVlpTEJBSVhDREVhQVF4eThVb2E3Y2VibUlYUWYrQkRLNitCbE9QRVRqNHErMkE3b3pFWnhZZ2g0M0pRR0pEdHVSRUVtYkFqYmVJbENIK1gycDVvVjJtTEZkWHlyQUZHM0VoZTBZR3diWjJXVERn&traceId=1",
      alt: "iPhone 17 Pro",
      headline: "RAFFLE TO WIN",
      subheadline: "iPhone 17 Pro",
      description: "Spend $50 for 1 raffle ticket. Drawn on Jan 31, 2026.",
    },
    {
      url: "https://www.apple.com/v/airpods-pro/r/images/overview/magical/magical_experience_live_translation__gjk070yu926a_large.jpg",
      alt: "AirPods Pro 3",
      headline: "RAFFLE TO WIN",
      subheadline: "AirPods Pro 3",
      description: "Spend $50 for 1 raffle ticket. Drawn on Jan 31, 2026.",
    },
  ];

  const scroll = (direction) => {
    if (scrollRef.current) {
      const scrollAmount = direction === "left" ? -window.innerWidth : window.innerWidth;
      scrollRef.current.scrollBy({ left: scrollAmount, behavior: "smooth" });
    }
  };

  return (
    <div className="promo-wrapper">
      <button className="scroll-btn left" onClick={() => scroll("left")}>‹</button>
      <div className="promocardContainer" ref={scrollRef}>
        {promos.map((promo, index) => (
          <div key={index} className="promo-item">
            <div
              className="promocard"
              style={{ backgroundImage: `url(${promo.url})` }}
              aria-label={promo.alt}
            />
            <br/>
            <div className="promoimage">
              <div className="promo-details">
                <h1>{promo.headline}</h1>
                <h3 className="promo-subheadline">{promo.subheadline}</h3>
                <p>{promo.description}</p>
              </div>
            </div>
          </div>
        ))}
      </div>

      <button className="scroll-btn right" onClick={() => scroll("right")}>›</button>
    </div>
  );
}

export default PromoCard;